// @ts-nocheck
import { Button } from "@shared/antd/button";
import React, { useEffect, useState } from "react";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { PropsCarousel } from "../../../widgets";
import { TimeLinePath } from "../../../home/timeline/TimeLineItemFull";
import Img from "../../../components/Img";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { FeedItemModel } from "../../types/feed-item-model";

interface CarouselProps {
  propsCarouse: PropsCarousel;
}

export const CarouselCustomComponent = (props: CarouselProps) => {
  const [total, setTotal] = useState<number>(0);
  const intl = useIntl();
  const {
    imagesCarouselElements,
    current,
    sliderInfo,
    slidePerPage = 1,
  } = props.propsCarouse;

  useEffect(() => {
    if (imagesCarouselElements) {
      setTotal(sliderInfo.length);
    }
  }, [imagesCarouselElements, sliderInfo.length]);
  const history = useHistory();
  const handleRedirectClick = (item: FeedItemModel) => {
    if (item.url) {
      window.location.href = item.url;
      return;
    }
    const { id, text, title, url, img, date } = item;
    history.push({
      pathname: `${TimeLinePath}/${id}`,
      state: { id, title, text, date, img, url },
    });
  };
  const decodeHtmlEntities = (html: string) => {
    const div = document.createElement("div"); // Используем div вместо textarea
    div.innerHTML = html;
    return div.textContent || div.innerText || ""; // Возвращаем содержимое div
  };

  return (
    <CarouselProvider
      naturalSlideWidth={125}
      naturalSlideHeight={125}
      isIntrinsicHeight={true}
      currentSlide={current}
      totalSlides={total}
      visibleSlides={slidePerPage}
    >
      <Slider className={"-ml-2"}>
        {sliderInfo.map((item, index) => (
          <Slide
            key={index}
            index={index}
            id={"carouselID"}
            className={
              "mx-2 bg-white rounded border border-[#D0D5DD] h-full cursor-pointer"
            }
            onClick={() => handleRedirectClick(item)}
          >
            <div
              className={
                "bg-gray-300 min-w-full h-[20rem] max-h-[20rem] lg:h-44 lg:min-h-44 lg:max-h-44 relative"
              }
            >
              <Img
                className={"w-full h-full object-cover"}
                type="promise"
                src={item.img}
              />
            </div>
            <div className={"px-2 py-3 text-sm mt-auto custom-scroll-bar"}>
              <div className="h-20">
                <h5 className={"text-primary-active line-clamp-3"}>
                  {item.title}
                </h5>
              </div>
              <div>
                <p className={"text-text-grey-dark break-words line-clamp-6"}>
                  {decodeHtmlEntities(item.text)}
                </p>
                <Button
                  onClick={() => handleRedirectClick(item)}
                  style={{ margin: 0, padding: 0 }}
                  type="link"
                >
                  {intl.formatMessage({ id: "more" })}
                </Button>
              </div>
              {/* <Button type="link" onClick={() => handleRedirectClick(item)}>
                more
              </Button> */}
            </div>
          </Slide>
        ))}
      </Slider>
    </CarouselProvider>
  );
};
